import {ueCommonTheme, ueAccentColors} from './ueCommonTheme';
import {darken} from '@material-ui/core/styles/colorManipulator';
import {createEpicTheme} from '@epic-ui/theme/dist/createEpicTheme';
import {UeThemeOptions, UeTheme} from './ueTheme.types';
import {makeFormStyleOverrides} from './ueFormStyles';
import {Overrides} from '@material-ui/core/styles/overrides';

const lightColors = {
    background: {
        default: ueCommonTheme.palette.neutral.stone,
        paper: ueCommonTheme.palette.neutral.chalk,
        paperpop: ueCommonTheme.palette.neutral.pearl
    }
};

export const lightThemeConfig: UeThemeOptions = {
    ...ueCommonTheme,
    palette: {
        ...ueCommonTheme.palette,
        type: 'light',
        background: {
            default: lightColors.background.default,
            defaultShade: (number: number): string => {
                return darken(lightColors.background.default, number);
            },
            paper: lightColors.background.paper,
            paperpop: lightColors.background.paperpop
        },
        accent: {
            ...ueCommonTheme.palette.accent,
            ...ueAccentColors.dark
        },
        text: {
            secondary: ueCommonTheme.palette.neutral.steel
        },
        misc: {
            outline: ueCommonTheme.palette.neutral.charcoal
        }
    },
    name: 'ueLight',
    ue: {
        ...ueCommonTheme.ue,
        name: 'ueLight',
        colors: {
            buttons: {
                primary: {
                    background: {
                        default: '#0aaff1',
                        hover: '#008dc5',
                        disabled: '#008dc5'
                    },
                    border: {
                        default: '#0aaff1',
                        hover: '#008dc5',
                        disabled: '#008dc5'
                    },
                    text: {
                        default: '#fff',
                        hover: '#fff',
                        disabled: '#ccc'
                    }
                },
                secondary: {
                    background: {
                        default: 'rgba(17,17,17,.1)',
                        hover: '#0aaff1',
                        disabled: ''
                    },
                    border: {
                        default: '#0aaff1',
                        hover: '#0aaff1',
                        disabled: '#3d3d3d'
                    },
                    text: {
                        default: '#fff',
                        hover: '#fff',
                        disabled: '#3d3d3d'
                    }
                },
                tertiary: {
                    background: {
                        default: 'rgba(0,0,0,.5)',
                        hover: 'rgba(0,0,0,.5)',
                        disabled: ''
                    },
                    border: {
                        default: '#757575',
                        hover: '#fff',
                        disabled: '#3d3d3d'
                    },
                    text: {
                        default: '#cecece',
                        hover: '#fff',
                        disabled: '#3d3d3d'
                    }
                },
                black: {
                    background: {
                        default: '#000',
                        hover: 'rgba(0,0,0,.8)',
                        disabled: ''
                    },
                    border: {
                        default: '#000',
                        hover: '#rgba(0,0,0,.8)',
                        disabled: '#3d3d3d'
                    },
                    text: {
                        default: '#fff',
                        hover: '#fff',
                        disabled: '#3d3d3d'
                    }
                },
                circular: {
                    background: {
                        default: 'rgba(0,0,0,.5)',
                        hover: 'rgba(0,0,0,.5)',
                        disabled: ''
                    },
                    border: {
                        default: '#cecece',
                        hover: '#fff',
                        disabled: '#3d3d3d'
                    },
                    text: {
                        default: '#cecece',
                        hover: '#fff',
                        disabled: '#3d3d3d'
                    }
                },
                link: {
                    default: '#0aaff1',
                    hover: '#088bc0'
                },
                twinmotion: {
                    default: '#f73476',
                    hover: '#f96597'
                }
            },
            cards: {
                default: {
                    background: '#232323'
                },
                inverted: {
                    background: '#f5f5f5'
                },
                overlay: {
                    background: 'rgba(0,0,0,.35)'
                }
            },
            primary: '#0aaff1'
        }
    }
};

lightThemeConfig.overrides = makeFormStyleOverrides(lightThemeConfig) as Overrides;

export const ueLightTheme = createEpicTheme(lightThemeConfig) as UeTheme;
